import React from "react";
import SbEditable from "storyblok-react"
import Button from 'src/components/Button'



const RelatedContentCard = ({ blok }) => {
    return (
        <SbEditable content={blok} key={blok._uid}>

            <div className="z-10 bg-cover bg-center">
                <div className="bg-cover bg-center"
                   style={{
                    backgroundImage: blok.Gradient ? "url('/cloud-gradient.svg')" : undefined,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}>

                    <div className="max-w-[1004px] mx-auto px-4 py-12 z-10 relative">
                        <div className="flex justify-center md:justify-end">
                            {/* Replace with your own illustration or image */}
                            <img
                                src={blok.Img.filename}
                                alt="Cloud Illustration"
                                className="w-full max-w-sm z-[2]"
                            />
                        </div>
                        <div>
                            <p className="text-sm text-[#002432] font-semibold uppercase mb-2">{blok.Lable}</p>
                            <h4 className="text-3xl md:text-5xl font-display font-semibold tracking-[-0.05em]">
                                {blok.title}
                            </h4>
                            <Button
                                to={blok.button_target?.cached_url}
                                className={`!rounded-full  mt-9 ${blok.Gradient ? "border-black" : ''} !text-[#002432] border-2 hover before:!bg-slate-50`}
                                before={blok.button_text}
                                variant="default"
                            >
                                {blok.Button_title}
                            </Button>
                        </div>



                        <div className="mt-12 flex flex-wrap gap-8 z-10">
                            {blok.Blok.map((article) => {
                                return (
                                    <div className="max-w-330px] mx-auto">
                                        <div key={article.id} className="bg-white shadow p-6 rounded-2xl mb-5">
                                            <img
                                                src={article.Img.filename}
                                                alt="Cloud Illustration"
                                                className="w-full max-w-sm"
                                            />

                                        </div>
                                        <h2 className="text-sm font-semibold">{article.title}</h2>
                                        <p className="text-2xl font-semibold mt-2">{article.heading}</p>
                                        <Button
                                            to={blok.button_target?.cached_url}
                                            className='bg-[#002432] !rounded-full hover before:content-[attr(before)] mt-9'
                                            before={blok.button_text}
                                        >
                                            {blok.Button_title}
                                        </Button>
                                    </div>
                                )
                            })}
                        </div>

                    </div>
                </div>
            </div>

        </SbEditable>
    );
};

export default RelatedContentCard;